import React from "react";
import { IoCloseCircle } from "react-icons/io5";
import { generateRandomKey } from "../helpers/generateRandomKey";
import i18n from '../i18n';

export function notifyAndInviteToSubscribe(noticeService, error, setShowLoginModal) {
  const newNoticeKey = generateRandomKey();
  noticeService.open({
    key: newNoticeKey,
    duration: 30,
    content: (
      <div>
        <div className="d-flex justify-content-between align-items-center mr-1">
          <small className="tag">{i18n.t('common.ops')}</small>
          <strong>{i18n.t('notifications.usageLimit')}</strong>
        </div>
        <div>{error.message} {i18n.t('notifications.subscribeToAvoid')}</div>
        <button
          onClick={() => {
            setShowLoginModal(true);
            noticeService.close(newNoticeKey);
          }}
          type="submit"
          className="navbar-item ms-0 mt-2"
        >
          {i18n.t('notifications.upgradeNow')}
        </button>
      </div>
    ),
    closable: true,
    showProgress: false,
    closeIcon: <IoCloseCircle />,
  });
}
